import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';
import { Router } from '@angular/router';
import { HttpClient } from '../_services/http.client';
import { SessionService } from '../_services/session.service';
import { AppSettings }from '../_models/app.settings';

@Component({
  selector: 'app-dashboard',
  templateUrl: './full-layout.component.html'
})
export class FullLayoutComponent implements OnInit {
  nombre:string = '';
  constructor(
    private localStorage : LocalStorageService,
    private router: Router,
    private http : HttpClient,
    private session : SessionService
  ) { }

  public disabled:boolean = false;
  public status:{isopen:boolean} = {isopen: false};

  public toggled(open:boolean):void {
  }

  public toggleDropdown($event:MouseEvent):void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isopen = !this.status.isopen;
  }

  logout():void{
    this.localStorage.remove('user');
    setTimeout(() => {
      this.router.navigate(['/pages/login']);
    },500);
  }

  ngOnInit(): void {
    this.nombre = this.session.get('nombre');
  }
}



// WEBPACK FOOTER //
// ./src/app/layouts/full-layout.component.ts